import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { getOptionsFromRefList } from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";

const DetentionInformation = ({
  arrestReport = {},
  form,
  disabled,
  startingPoint = "",
}) => {
  return (
    <section>
      <IntakeSectionHeader>
        <span>Detention Information</span>
      </IntakeSectionHeader>

      <FieldSecurityProvider
        entity="DetentionsArrestReports"
        startingPoint={startingPoint}
        bookingsFieldsEnabled={!disabled}
      >
        <FormContainer>
          <Row gutter={16}>

            {/* Detention # — always read-only, overrideDisabled forces it disabled
                regardless of field security */}
            <Col span={8}>
              <SecureFormItem
                fieldName="detentionId"
                overrideDisabled
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "detentionId"],
                  label: "Detention #",
                  layout: "vertical",
                }}
              >
                <TextField />
              </SecureFormItem>
            </Col>

            {/* Facility */}
            <Col span={8}>
              <SecureFormItem
                fieldName="housingAgency"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "housingAgency"],
                  label: "Facility",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList("Housing_Agency")}
                  placeholder="Facility"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>

            {/* Block — always read-only */}
            <Col span={8}>
              <SecureFormItem
                fieldName="housingAssignmentBlock"
                overrideDisabled
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "housingAssignmentBlock"],
                  label: "Block",
                  layout: "vertical",
                }}
              >
                <TextField />
              </SecureFormItem>
            </Col>

          </Row>
          <Row gutter={16}>

            {/* Incarcerated Date & Time */}
            <Col span={8}>
              <SecureFormItem
                fieldName="incarcerationDateTime"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "incarcerationDateTime"],
                  label: "Incarcerated Date & Time",
                  layout: "vertical",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime
                />
              </SecureFormItem>
            </Col>

            {/* Hold Reason */}
            <Col span={8}>
              <SecureFormItem
                fieldName="holdReasonId"
                formItemProps={{
                  name: ["detentionsArrestReports", 0, "holdReasonId"],
                  label: "Hold Reason",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList("Inmate_Hold_Reason", false, false, true)}
                  placeholder="Hold Reason"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>

          </Row>
        </FormContainer>
      </FieldSecurityProvider>
    </section>
  );
};

export default DetentionInformation;